<template>
    <div class="marketing" v-loading="loading">
        <div class="marketing-first">
            <div class="marketing-first-add" @click="addBtn">
                <img class="first-add-img" src="../../assets/common/common-add.png" />
                <div class="first-add-title">添加</div>
            </div>
        </div>

        <div class="marketing-second">
            <div class="marketing-second-table">
                <el-table :data="tableData" border style="width: 100%; cursor: pointer" :header-cell-style="{
        color: '#333333',
        backgroundColor: '#FAFAFA',
    }">
                    <!-- 自定义暂无数据 -->
                    <template slot="empty">
                        <div class="empty-block">
                            <img class="empty-block-img" src="../../assets/common/common-empty.png" />
                            <div class="empty-block-text">暂无数据～</div>
                        </div>
                    </template>

                    <el-table-column label="跳转类型">
                        <template slot-scope="scope">
                            {{
        scope.row.type == 1
            ? '商品'
            : scope.row.type == 2
                ? '外链'
                : scope.row.type == 3
                    ? '店铺认证'
                    : scope.row.type == 4
                        ? '金刚区'
                        : ''
    }}
                        </template>
                    </el-table-column>
                    <el-table-column label="轮播图图片" width="423">
                        <template slot-scope="scope">
                            <img class="table-img" :src="scope.row.image" alt="" />
                        </template>
                    </el-table-column>
                    <el-table-column label="停留秒速">
                        <template slot-scope="scope"> {{ scope.row.sec }}秒 </template>
                    </el-table-column>
                    <el-table-column prop="name" label="排序">
                        <template slot-scope="scope">
                            <div class="table-sort" @click="sortBtn(scope.row)">
                                <img class="table-sort-left" src="../../assets/marketing/marketing-no.png" alt="" />
                                <!-- <img
                  class="table-sort-left"
                  :src="
                    scope.row.isIndex == 1
                      ? require('../../assets/marketing/marketing-top.png')
                      : require('../../assets/marketing/marketing-no.png')
                  "
                  alt=""
                /> -->
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <div class="operation">
                                <div class="compile" @click="compileBtn(scope.row)">编辑</div>

                                <div class="delete" @click="deleteBtn(scope.row)">删除</div>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <div class="marketing-second-Pagination">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :page-sizes="[10, 20, 30, 40]" :page-size="10" layout="prev, pager, next, sizes" :total="tableNum">
                </el-pagination>
            </div>
        </div>

        <!--添加轮播图-->
        <div class="marketing-add">
            <el-dialog :visible.sync="addDialogVisible" width="444px" style="margin-top: 10vh" @close="resetBtn">
                <span slot="footer" class="dialog-footer">
                    <div class="marketing-add-block">
                        <div class="marketing-add-block-top">
                            <div class="block-top-title">轮播图添加</div>
                            <img class="block-top-close" src="../../assets/common/close.png" @click="resetBtn" />
                        </div>

                        <div class="marketing-add-block-center">
                            <div class="block-center-header">
                                <div class="header-title">轮播图类型</div>
                                <div class="header-input">
                                    <el-select v-model="addswiperType" clearable placeholder="请选择">
                                        <el-option v-for="item in addswiperList" :key="item.value" :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>

                            <div class="block-center-dispay">
                                <div class="center-dispay-left">
                                    <div class="center-dispay-left-title">轮播图图片</div>
                                    <div class="center-dispay-left-div">
                                        <div class="left-div-plate">
                                            <el-upload class="upload-img"
                                                action="https://laravel-api-manager.xmw1688.com/common/upload"
                                                list-type="picture-card" :on-success="handleSuccess"
                                                :show-file-list="false" ref="upload">
                                                <img v-if="addImage != ''" :src="addImage" class="avatar" />
                                                <img v-else src="../../assets/common/common-uploadings.png"
                                                    class="avatar" />

                                                <img class="detele" v-if="addImage != ''"
                                                    src="../../assets/common/common-detele.png" alt=""
                                                    @click.stop="masterDetele" />
                                            </el-upload>
                                            <!-- <img
                        class="left-div-plate-img"
                        src="../../assets/common/common-uploading.png"
                        alt=""
                      />
                      <div class="left-div-plate-text">上传图片</div> -->
                                        </div>
                                    </div>
                                </div>
                                <div class="center-dispay-right">
                                    <div class="center-dispay-right-title">
                                        {{
        addswiperType == 0
            ? '商品id'
            : addswiperType == 1
                ? '外链接'
                : '金刚区'
    }}
                                    </div>
                                    <div class="center-dispay-right-select">
                                        <el-input v-if="addswiperType == 0" placeholder="请输入商品id" v-model="addshopId"
                                            class="input-with-select">
                                        </el-input>

                                        <el-input v-if="addswiperType == 1" placeholder="请输入外链接"
                                            v-model="addExternallinks" class="input-with-select">
                                        </el-input>

                                        <el-select v-if="addswiperType == 2" v-model="prizeType" clearable
                                            placeholder="请选择">
                                            <el-option v-for="item in prizeList" :key="item.id" :label="item.name"
                                                :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </div>

                                    <div class="center-dispay-right-title">停留秒速</div>
                                    <div class="center-dispay-right-input">
                                        <el-input placeholder="请输入停留秒数" v-model="staySeconds" class="input-with-select">
                                            <div class="input-append" slot="append">秒</div>
                                        </el-input>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="marketing-add-block-button">
                            <!-- <div class="marketing-add-block-reset" @click="resetBtn">
                重置
              </div> -->
                            <div class="marketing-add-block-confirm" @click="confirmBtn">
                                确定
                            </div>
                        </div>
                    </div>
                </span>
            </el-dialog>
        </div>

        <!--编辑轮播图-->
        <div class="marketing-add">
            <el-dialog :visible.sync="compileDialogVisible" width="444px" style="margin-top: 10vh" @close="resetBtn">
                <span slot="footer" class="dialog-footer">
                    <div class="marketing-add-block">
                        <div class="marketing-add-block-top">
                            <div class="block-top-title">轮播图编辑</div>
                            <img class="block-top-close" src="../../assets/common/close.png" @click="resetBtn" />
                        </div>

                        <div class="marketing-add-block-center">
                            <div class="block-center-header">
                                <div class="header-title">轮播图类型</div>
                                <div class="header-input">
                                    <el-select v-model="addswiperType" clearable placeholder="请选择">
                                        <el-option v-for="item in addswiperList" :key="item.value" :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>

                            <div class="block-center-dispay">
                                <div class="center-dispay-left">
                                    <div class="center-dispay-left-title">轮播图图片</div>
                                    <div class="center-dispay-left-div">
                                        <div class="left-div-plate">
                                            <el-upload class="upload-img"
                                                action="https://laravel-api-manager.xmw1688.com/common/upload"
                                                list-type="picture-card" :on-success="handleSuccess" :limit="1"
                                                :show-file-list="false" ref="upload1">
                                                <img v-if="addImage != ''" :src="addImage" class="avatar" />
                                                <img v-else src="../../assets/common/common-uploadings.png"
                                                    class="avatar" />

                                                <img class="detele" v-if="addImage != ''"
                                                    src="../../assets/common/common-detele.png" alt=""
                                                    @click.stop="masterDetele" />
                                            </el-upload>
                                        </div>
                                    </div>
                                </div>
                                <div class="center-dispay-right1">
                                    <div class="center-dispay-right-title">
                                        {{
        addswiperType == 0
            ? '商品id'
            : addswiperType == 1
                ? '外链接'
                : '金刚区'
    }}
                                    </div>
                                    <div class="center-dispay-right-select">
                                        <el-input v-if="addswiperType == 0" placeholder="请输入商品id" v-model="addshopId"
                                            class="input-with-select">
                                        </el-input>
                                        <el-input v-if="addswiperType == 1" placeholder="请输入外链接"
                                            v-model="addExternallinks" class="input-with-select">
                                        </el-input>

                                        <el-select v-if="addswiperType == 2" v-model="prizeType" clearable
                                            placeholder="请选择">
                                            <el-option v-for="item in prizeList" :key="item.id" :label="item.name"
                                                :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </div>

                                    <div class="center-dispay-right-title">停留秒速</div>
                                    <div class="center-dispay-right-input">
                                        <el-input placeholder="请输入停留秒数" v-model="staySeconds" class="input-with-select">
                                            <div class="input-append" slot="append">秒</div>
                                        </el-input>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="marketing-add-block-button">
                            <!-- <div class="marketing-add-block-reset" @click="compileresetBtn">
                重置
              </div> -->
                            <div class="marketing-add-block-confirm" @click="compileconfirmBtn">
                                确定
                            </div>
                        </div>
                    </div>
                </span>
            </el-dialog>
        </div>

        <!--删除这条轮播图数据-->
        <div class="marketing-detele">
            <el-dialog :visible.sync="detDialogVisible" width="394px" style="margin-top: 15vh" :show-close="false"
                @close="deleteClose">
                <span slot="footer" class="dialog-footer">
                    <div class="detele-div">
                        <img class="detele-div-img" src="../../assets/common/common-warning.png" />
                        <div class="detele-div-title">确定是否删除该轮播图数据？</div>
                        <div class="detele-div-text">一旦确定则进行删除</div>
                        <div class="detele-div-button">
                            <div class="detele-div-button-left" @click="deteleRegister">
                                确定
                            </div>
                            <div class="detele-div-button-right" @click="deleteClose">
                                取消
                            </div>
                        </div>
                    </div>
                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import {
    getMarketSwiperList,
    getMarketSwiperdetail,
    deletefnMarketSwiper,
    putfnMarketSwiper,
    postfnMarketSwiperAdd,
    getMarketKingList,
} from '../../api/marketing'

import { isPositiveInteger } from '../../utils/verify'

export default {
    comments() { },
    data() {
        return {
            // 添加轮播图的弹窗开启 false 关闭 true 开启
            addDialogVisible: false,
            // 添加轮播图中弹出轮播图类型
            addswiperList: [
                {
                    value: 0,
                    label: '商品',
                },
                {
                    value: 1,
                    label: '外链',
                },
                {
                    value: 2,
                    label: '金刚区',
                },
            ],
            // 添加轮播图类型
            addswiperType: 0,
            // 添加轮播图 弹出 商品id
            addshopId: '',
            // 添加轮播图 弹出  外链接
            addExternallinks: '',
            // 添加轮播图 弹出  停留秒数
            staySeconds: '',
            // 添加轮播图 弹出  图片
            addImage: '',
            // 表格数据
            tableData: [],
            // 表格数据 总条数
            tableNum: 0,

            /* 编辑轮播图模块 */
            compileDialogVisible: false,
            // 编辑轮播图 金刚区id
            compilejingangId: '',
            // 编辑轮播图 id
            compileId: '',
            // 编辑轮播图获取一级列表
            prizeList: [],
            // 编辑轮播图 获取二级列表
            prizeType: '',

            /* 商品栏删除按钮 */
            detDialogVisible: false,
            // 页码
            page: 1,
            // 页数
            limit: 10,
            // 监听用户刷新
            loading: false,
            // 控制当前页面功能性按钮开关
            marketingFunShow: false,
        }
    },
    created() {
        // 获取轮播图列表
        this.loading = true
        this.getMarketSwiperClick()
        // 获取金刚区列表
        this.getMarketKingClick()

        setTimeout(() => {
            this.marketingFunShow = this.$store.state.pageFunctionShow

        }, 1000);
    },
    methods: {
        // 获取轮播图的列表
        getMarketSwiperClick() {
            let params = {
                pageSize: this.limit,
                pageNo: this.page,
            }

            getMarketSwiperList(params).then((res) => {
                if (res.resultStatus == true) {
                    console.log('用户点击', res)
                    // 表格数组
                    this.tableData = res.resultData.bannerList
                    // 表格数组总条数
                    this.tableNum = res.resultData.totalNum
                    this.loading = false
                }
            })
        },

        // 用户点击弹出开启
        addBtn() {
            if (this.marketingFunShow == false) {
                return
            }
            this.addDialogVisible = true
        },
        // 用户点击弹出开启  重置按钮
        resetBtn() {
            this.addswiperType = 0
            this.addImage = ''
            this.addExternallinks = ''
            this.addshopId = ''
            this.staySeconds = ''
            this.compileId = ''
            this.prizeType = ''

            this.addDialogVisible = false
            this.compileDialogVisible = false
        },
        // 用户点击弹出开启   确定按钮
        confirmBtn(index) {
            console.log(index)
            // 添加按钮、
            if (!isPositiveInteger(this.staySeconds)) {
                this.$message.error('秒数格式不正确, 请输入正整数')
                return
            }

            if (this.addImage == '') {
                this.$message.error('上传图片不能为空！')
                return
            }

            let params = {
                id: this.compileId, // id
                type:
                    this.addswiperType == 0
                        ? 1
                        : this.addswiperType == 1
                            ? 2
                            : this.addswiperType == 2
                                ? 4
                                : this.addswiperType == 3
                                    ? 3
                                    : '', // 跳转类型:1=商品,2=外链,3=店铺认证,4=金刚区
                image: this.addImage, // 图片
                sec: this.staySeconds, // 停留秒数
                url: this.addExternallinks, // 外链接
                goods_id: this.addshopId, // 商品id
                jingang_id: this.prizeType, // 金刚区id
            }

            postfnMarketSwiperAdd(params).then((res) => {
                if (res.resultStatus == true) {
                    this.$message({
                        message: index == 1 ? '修改成功！' : '添加成功！',
                        type: 'success',
                    })
                    this.loading = true

                    this.addDialogVisible = false
                    this.compileDialogVisible = false
                    this.getMarketSwiperClick()
                }
            })
        },
        // 用户点击商品栏编辑
        compileBtn(item) {
            if (this.marketingFunShow == false) {
                return
            }

            console.log('点击编辑栏', item)
            let params = item.id

            getMarketSwiperdetail(params).then((res) => {
                if (res.resultStatus == true) {
                    console.log('获取详情', res)
                    this.addswiperType =
                        res.resultData.type == 1
                            ? 0
                            : res.resultData.type == 2
                                ? 1
                                : res.resultData.type == 3
                                    ? 3
                                    : res.resultData.type == 4
                                        ? 2
                                        : ''
                    this.addshopId = res.resultData.goods_id
                    this.addImage = res.resultData.image
                    this.staySeconds = res.resultData.sec
                    this.addExternallinks = res.resultData.url
                    this.compileId = res.resultData.id
                    this.prizeType = res.resultData.jingang_id // 金刚区id

                    this.compileDialogVisible = true
                }
            })
        },
        /* 编辑模块 */
        // 编辑弹出框 重置
        compileresetBtn() {
            this.prizeType = ''
            this.compileDialogVisible = false
        },
        // 编辑弹出框 确定
        compileconfirmBtn() {
            this.confirmBtn(1)
        },
        // 修改轮播图 移入
        mouseoverBtn() {
            this.immigration = true
        },
        // 修改轮播图 移出
        mouseoutBtn() {
            console.log('移出')
            this.immigration = false
        },

        // 商品区域 排序
        sortBtn(item) {
            if (this.marketingFunShow == false) {
                return
            }

            console.log(item)
            let params = item.id
            putfnMarketSwiper(params).then((res) => {
                if (res.resultStatus == true) {
                    this.loading = true
                    this.$message({
                        message: '置顶成功',
                        type: 'success',
                    })
                    this.loading = true
                    this.getMarketSwiperClick()
                }
            })
        },

        /* 删除 */
        // 用户点击商品栏删除
        deleteBtn(item) {
            if (this.marketingFunShow == false) {
                return
            }

            this.addshopId = item.id
            this.detDialogVisible = true
        },
        deleteClose() {
            this.addshopId = ''
            this.detDialogVisible = false
        },
        deteleRegister() {
            let params = this.addshopId

            deletefnMarketSwiper(params).then((res) => {
                if (res.resultStatus == true) {
                    this.$message({
                        message: '删除成功！',
                        type: 'success',
                    })
                    this.detDialogVisible = false
                    this.loading = true
                    this.getMarketSwiperClick()
                }
            })
        },

        // 上传成功
        handleSuccess(file, fileList) {
            this.$refs.upload.clearFiles()
            this.$refs.upload1.clearFiles()
            this.addImage = file.resultData
        },
        masterDetele() {
            this.addImage = ''
        },

        // 获取金刚区一级列表
        getMarketKingClick() {
            let params = {
                pageSize: 9999,
                pageNo: 1,
            }
            getMarketKingList(params).then((res) => {
                console.log('获取列表数据', res)
                if (res.resultStatus == true) {
                    this.prizeList = res.resultData.jinList
                }
            })
        },

        // 查询当前页码多少条
        handleSizeChange(val) {
            this.limit = val
            this.loading = true
            console.log(`每页 ${val} 条`)
            this.getMarketSwiperClick()
        },
        // 查询当前页
        handleCurrentChange(val) {
            this.page = val
            this.loading = true
            console.log(`当前页: ${val}`)
            this.getMarketSwiperClick()
        },
    },
}
</script>
<style lang="less" scoped>
/deep/ .el-input__inner:focus {
    border-color: rgba(217, 217, 217, 1);
}

/deep/ .el-textarea__inner:focus {
    border-color: rgba(217, 217, 217, 1);
}

/deep/ .el-select .el-input.is-focus .el-input__inner {
    border-color: rgba(255, 255, 255, 0);
}

.marketing {
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px #edeff7;
    border-radius: 10px;
    padding: 0 24px;
    box-sizing: border-box;

    .marketing-first {
        width: 100%;
        height: 80px;
        display: flex;
        align-items: center;
        justify-content: flex-start;

        .marketing-first-add {
            width: 82px;
            height: 36px;
            background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
            border-radius: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            .first-add-img {
                width: 13px;
                height: 13px;
            }

            .first-add-title {
                margin-left: 8px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #ffffff;
            }
        }
    }

    .marketing-second {
        .marketing-second-table {
            /deep/ .el-table .el-table__cell {
                padding: 0;
            }

            /deep/ .el-table__header-wrapper {
                height: 46px;
                background: #d8d8d8;
                display: flex;
                align-items: center;
            }

            /deep/ table.el-table__header {
                height: 100%;
            }

            /deep/ .el-table tr {
                height: 110px;
            }

            /deep/ .el-table__empty-text {
                line-height: 0;
            }

            .empty-block {
                margin-top: 62px;
                padding-bottom: 40px;

                .empty-block-img {
                    width: 130px;
                    height: 130px;
                    margin: 0 auto;
                }

                .empty-block-text {
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #999999;
                    margin-top: 10px;
                    height: 17px;
                    line-height: 17px;
                }
            }

            .table-img {
                width: 176px;
                height: 86px;
                border-radius: 5px;
            }

            .table-sort {
                display: flex;

                .table-sort-left,
                .table-sort-right {
                    width: 26px;
                    height: 26px;
                }

                .table-sort-right {
                    margin-left: 4px;
                }
            }

            .operation {
                display: flex;

                .compile,
                .delete {
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #2aa4ff;
                    text-decoration: underline;
                }

                .delete {
                    margin-left: 24px;
                }
            }
        }

        .marketing-second-Pagination {
            height: 88px;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            /deep/ .el-pagination .btn-prev {
                padding: 0;
                width: 32px;
                height: 32px;
                background: #ffffff;
                border-radius: 2px;
                border: 1px solid #d9d9d9;
                margin-right: 8px;
            }

            /deep/ .el-pagination .btn-next {
                padding: 0;
                width: 32px;
                height: 32px;
                background: #ffffff;
                border-radius: 2px;
                border: 1px solid #d9d9d9;
            }

            /deep/ .el-pager li {
                padding: 0;
                width: 32px;
                height: 32px;
                background: #ffffff;
                border-radius: 2px;
                border: 1px solid #d9d9d9;
                line-height: 32px;
                margin-right: 8px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.65);
            }

            /deep/ .el-pager li.active {
                background: #000000;
                color: #ffffff;
            }

            /deep/ .el-input--mini .el-input__inner {
                height: 32px;
            }

            /deep/ .el-input__inner {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.65);
            }
        }
    }

    .marketing-add {
        /deep/ .el-dialog {
            height: 350px;
        }

        /deep/ .el-dialog__footer {
            padding: 0;
            text-align: left;
        }

        .marketing-add-block {
            .marketing-add-block-top {
                display: flex;
                height: 56px;
                align-items: center;
                justify-content: space-between;
                padding: 0 24px;
                box-sizing: border-box;
                border-bottom: 1px solid #e9edf4;

                .block-top-title {
                    font-size: 16px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #222222;
                }

                .block-top-close {
                    width: 10px;
                    height: 10px;
                    cursor: pointer;
                }
            }

            .marketing-add-block-center {
                padding: 0 24px;
                box-sizing: border-box;
                margin-top: 20px;

                .block-center-header {
                    .header-title {
                        font-size: 12px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #333333;
                    }

                    .header-input {
                        border-radius: 5px;
                        margin-top: 4px;

                        /deep/i.el-select__caret.el-input__icon.el-icon-arrow-up {
                            display: flex;
                            align-items: center;
                        }

                        /deep/ .el-select {
                            width: 100%;
                        }

                        /deep/ .el-input--suffix .el-input__inner {
                            height: 32px;
                        }

                        /deep/ .el-select .el-input.is-focus .el-input__inner {
                            border-color: rgba(217, 217, 217, 1);
                        }
                    }
                }

                .block-center-dispay {
                    display: flex;
                    margin-top: 16px;

                    .center-dispay-left {
                        .center-dispay-left-title {
                            font-size: 12px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #333333;
                        }

                        .center-dispay-left-div {
                            width: 100px;
                            height: 100px;
                            background: rgba(0, 0, 0, 0.02);
                            border-radius: 5px;
                            border: 1px solid rgba(0, 0, 0, 0.15);
                            margin-top: 8px;
                            display: flex;
                            align-items: center;
                            justify-content: center;

                            .left-div-plate {
                                width: 100px;
                                height: 100px;
                                cursor: pointer;
                                position: relative;

                                .upload-img {
                                    width: 100px;
                                    height: 100px;
                                    position: relative;

                                    /deep/ .el-upload--picture-card {
                                        width: 100px;
                                        height: 100px;
                                        display: flex;
                                        align-items: center;
                                        justify-content: center;
                                        border: 1px solid rgba(255, 255, 255, 0);
                                    }

                                    /deep/ .el-upload--picture-card:hover {
                                        border-color: rgba(255, 255, 255, 0);
                                    }

                                    /deep/ .el-upload-list--picture-card .el-upload-list__item {
                                        width: 100px;
                                        height: 100px;
                                        margin: 0;
                                    }

                                    .avatar {
                                        width: 100px;
                                        height: 100px;
                                    }

                                    .detele {
                                        position: absolute;
                                        top: -10px;
                                        right: -10px;
                                        width: 20px;
                                        height: 20px;
                                    }
                                }
                            }
                        }

                        .center-dispay-left-view {
                            width: 132px;
                            height: 76px;
                            margin-top: 8px;
                            position: relative;
                            cursor: pointer;

                            .left-view-img {
                                width: 132px;
                                height: 76px;
                            }

                            .layer {
                                width: 132px;
                                height: 76px;
                                position: absolute;
                                top: 0;
                                left: 0;
                                right: 0;
                                bottom: 0;
                                background: rgba(0, 0, 0, 0.6);
                                z-index: 99;
                                display: flex;
                                align-items: center;
                                justify-content: center;

                                .layer-div {
                                    text-align: center;

                                    .layer-div-img {
                                        width: 24px;
                                        height: 24px;
                                    }

                                    .layer-div-text {
                                        font-size: 12px;
                                        font-family: PingFangSC-Medium, PingFang SC;
                                        font-weight: 500;
                                        color: #ffffff;
                                        margin-top: 2px;
                                    }
                                }
                            }
                        }
                    }

                    .center-dispay-right,
                    .center-dispay-right1 {
                        margin-left: 58px;
                        width: 100%;

                        .center-dispay-right-title {
                            font-size: 12px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #333333;
                        }

                        .center-dispay-right-select {
                            margin-top: 4px;
                            margin-bottom: 14px;

                            /deep/ .el-select {
                                width: 100%;
                            }

                            /deep/ .el-input--suffix .el-input__inner {
                                height: 32px;
                            }

                            /deep/ .el-select .el-input.is-focus .el-input__inner {
                                border-color: rgba(217, 217, 217, 1);
                            }

                            /deep/ .el-input {
                                height: 32px;
                            }

                            /deep/ .el-input__inner {
                                padding: 0 10px;
                                box-sizing: border-box;
                                height: 32px;
                                background-color: rgba(255, 255, 255, 0);
                            }
                        }

                        .center-dispay-right-input {
                            width: 100%;
                            margin-top: 4px;

                            /deep/ .el-input-group__append {
                                background-color: #ffffff;
                                height: 32px;
                                padding: 0;
                            }

                            /deep/ .el-input {
                                height: 32px;
                            }

                            /deep/ .el-input__inner {
                                padding: 0 10px;
                                box-sizing: border-box;
                                height: 32px;
                                background-color: rgba(255, 255, 255, 0);
                            }

                            .input-append {
                                width: 38px;
                                height: 30px;
                                background: #ffffff;
                                border-radius: 0px 5px 5px 0px;
                                text-align: center;
                                line-height: 32px;
                                font-size: 14px;
                                font-family: PingFangSC-Regular, PingFang SC;
                                font-weight: 400;
                                color: #555555;
                            }
                        }
                    }

                    .center-dispay-right1 {
                        margin-left: 26px;
                    }
                }
            }

            .marketing-add-block-button {
                display: flex;
                height: 52px;
                align-items: center;
                justify-content: flex-end;
                padding: 0 24px;
                box-sizing: border-box;
                margin-top: 20px;
                border-top: 1px solid #e9edf4;

                .marketing-add-block-reset,
                .marketing-add-block-confirm {
                    width: 65px;
                    height: 32px;
                    background: #ffffff;
                    border-radius: 10px;
                    border: 1px solid #e9edf4;
                    text-align: center;
                    line-height: 32px;
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #555555;
                    cursor: pointer;
                }

                .marketing-add-block-confirm {
                    background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
                    color: #ffffff;
                    margin-left: 8px;
                }
            }
        }
    }

    .marketing-detele {
        /deep/ .el-dialog {
            height: 231px;
        }

        .detele-div {
            text-align: center;

            .detele-div-img {
                width: 56px;
                height: 56px;
            }

            .detele-div-title {
                height: 32px;
                font-size: 18px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.85);
                line-height: 32px;
            }

            .detele-div-text {
                width: 319px;
                height: 40px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.45);
                line-height: 20px;
                margin: 0 auto;
                margin-top: 2px;
            }

            .detele-div-button {
                width: 100%;
                height: 32px;
                margin-top: 18px;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;

                .detele-div-button-left,
                .detele-div-button-right {
                    width: 88px;
                    height: 32px;
                    background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
                    border-radius: 10px;
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #ffffff;
                    line-height: 32px;
                }

                .detele-div-button-right {
                    width: 88px;
                    height: 32px;
                    background: #ffffff;
                    border-radius: 10px;
                    border: 1px solid #e9edf4;
                    margin-left: 10px;

                    color: rgba(0, 0, 0, 0.65);
                }
            }
        }
    }
}
</style>
